// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionsView_container__HHivk"};